import { FacilityAdmins } from './../models/facility-admin.model';
export const facilityAdminsMock: FacilityAdmins[] = [
  {
    createdAt: '2026-01-26T17:34:31.165Z',
    updatedAt: '2026-01-26T17:34:31.165Z',
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    facilityId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    userId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    positionId: 0,
    roleId: 0,
    firstName: 'string',
    lastName: 'string',
    email: 'string',
    phone: 'string',
    hireDate: '2026-01-26',
    hourlyWage: 0,
    salary: 0,
    employmentTypeId: 0,
    employmentTypeName: 'string',
    isActive: true,
    terminationDate: '2026-01-26',
    terminationReason: 'string',
    isRehireEligible: true,
    position: {
      id: 0,
      facilityId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      name: 'string',
      abbreviation: 'string',
      description: 'string',
      isActive: true,
      createdAt: '2026-01-26T17:34:31.165Z'
    },
    role: {
      id: 0,
      facilityId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      name: 'string',
      description: 'string',
      isProtected: true,
      isActive: true,
      permissionTypeIds: [0],
      permissionNames: ['string'],
      createdAt: '2026-01-26T17:34:31.165Z',
      updatedAt: '2026-01-26T17:34:31.165Z',
      userCount: 0
    }
  }
];
